// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"850b7c21","821":"e7cde120","977":"2218e483"}[chunkId] + ".chunk.js";
};